module.exports = __webpack_public_path__ + "static/img/3.b42fd84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/3.png
// module id = PTz7
// module chunks = 0